<ng-container class="row">
  <span *ngIf="summary !== null; else noSummary" class="filter-summary">
    {{ this.formatSummary() }}
  </span>
  <ng-template #noSummary>
    <span class="filter-summary">
      {{ 'FILTERS.CHOOSE-FILTER' | translate }}
    </span>
  </ng-template>

  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    [ngStyle]="{ color: buttonColor, background: backgroundColor }"
  >
    <mat-icon>filter_list</mat-icon>
  </button>
</ng-container>

<mat-menu #menu="matMenu" id="filter-component">
  <form
    #filterform="ngForm"
    (ngSubmit)="onFormSubmit(filterform)"
    (click)="$event.stopPropagation()"
    (keydown.tab)="$event.stopPropagation()"
    class="filter-menu-container"
  >
    <h3>
      {{ displayTitle | translate }}
    </h3>

    <div class="resize-content">
      <span *ngFor="let field of fieldDefinitions">
        <span [ngSwitch]="field.type">
          <!-- text fields -->
          <div *ngSwitchCase="'text'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <input
                [(ngModel)]="field.value"
                name="{{ field.name }}"
                matInput
                type="text"
                placeholder="{{ field.placeholder }}"
                #validation="ngModel"
                minlength="{{ field.minLength }}"
                maxlength="{{ field.maxLength }}"
                required="{{ field.required ? true : false }}"
              />
              <mat-error *ngIf="validation.errors?.required">
                {{ field.name }} is required</mat-error
              >
              <mat-error *ngIf="validation.errors?.minlength">
                Minimum characters required: {{ field.minLength }}
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'numbers'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <input
                [(ngModel)]="field.value"
                name="{{ field.name }}"
                matInput
                type="number"
                placeholder="{{ field.placeholder }}"
                #validation="ngModel"
                minlength="{{ field.minLength }}"
                maxlength="{{ field.maxLength }}"
                required="{{ field.required ? true : false }}"
              />
              <mat-error *ngIf="validation.errors?.required">
                {{ field.name }} is required</mat-error
              >
              <mat-error *ngIf="validation.errors?.minlength">
                Minimum characters required: {{ field.minLength }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- select fields -->
          <div *ngSwitchCase="'select'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <mat-select
                name="{{ field.name }}"
                placeholder="{{ field.placeholder | translate }}"
                [(ngModel)]="field.value"
                #validation="ngModel"
                required="{{ field.required ? true : false }}"
                (selectionChange)="checkOverride(field)"
              >
                <mat-option
                  *ngFor="let option of field.options"
                  [value]="option.value"
                >
                  {{ option.viewValue | translate }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validation.errors?.required">
                {{ field.name | translate }} is required</mat-error
              >
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'multiple-select'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <mat-select
                name="{{ field.name }}"
                placeholder="{{ field.placeholder }}"
                [(ngModel)]="field.value"
                #validation="ngModel"
                required="{{ field.required ? true : false }}"
                multiple
              >
                <mat-option
                  *ngFor="let option of field.options"
                  [value]="option.value"
                >
                  {{ option.viewValue }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validation.errors?.required">
                {{ field.name }} is required</mat-error
              >
            </mat-form-field>
          </div>

          <!-- radio fields -->
          <div *ngSwitchCase="'radio'">
            <mat-radio-group
              ngModel
              name="{{ field.name }}"
              class="vertical-list"
            >
              <mat-radio-button
                class="margin-8-width"
                *ngFor="let option of field.options"
                value="{{ option.value }}"
              >
                {{ option.viewValue }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <!-- checkbox fields -->
          <div *ngSwitchCase="'checkbox'" class="margin-8-width">
            <mat-checkbox
              [(ngModel)]="field.value"
              name="{{ field.name }}"
              [disabled]="field.disabled"
              [labelPosition]="field.labelPosition"
              required
            >
              {{ field.name }}
            </mat-checkbox>
          </div>

          <!-- switch fields -->
          <div *ngSwitchCase="'switch'" class="margin-8-width">
            <mat-slide-toggle
              [(ngModel)]="field.value"
              name="{{ field.name }}"
              [color]="color"
              [disabled]="field.disabled"
            >
              {{ field.name }}
            </mat-slide-toggle>
          </div>

          <!-- date fields -->
          <div *ngSwitchCase="'datepicker'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <input
                matInput
                name="{{ field.name }}"
                [(ngModel)]="field.value"
                placeholder="{{ field.placeholder }}"
                [matDatepicker]="datepicker"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="datepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'rangedatepicker'">
            <mat-form-field
              id="date-picker-form"
              appearance="outline"
              [floatLabel]="'always'"
              (click)="openPicker()"
            >
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <div class="d-flex align-items-center date-ranges">
                <mat-date-range-input
                  id="date-picker"
                  class="align-items-center"
                  matInput
                  [rangePicker]="picker"
                  readonly
                  [min]="field.minDate"
                  [max]="field.maxDate"
                  (click)="openPicker()"
                  (dateChange)="checkOverride(field)"
                >
                  <input
                    class="date-range-input"
                    placeholder="Start date"
                    [(ngModel)]="range.start"
                    (ngModelChange)="onModelChangeDataRange()"
                    name="start"
                    matStartDate
                  />
                  <input
                    class="date-range-input date-range-input-right"
                    placeholder="End date"
                    name="end"
                    [(ngModel)]="range.end"
                    (ngModelChange)="onModelChangeDataRange()"
                    matEndDate
                  />
                </mat-date-range-input>

                <button
                  id="erase-btn"
                  type="button"
                  class="filter-cancel-btn"
                  mat-flat-button
                  (click)="eraseField(field)"
                >
                  <mat-icon>close</mat-icon>
                </button>

                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </div>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'timepicker'">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
              <mat-label *ngIf="field.translation">{{
                field.translation | translate
              }}</mat-label>
              <input
                matInput
                name="{{ field.name }}"
                value="{{ field.value }}"
                [ngxMatTimepicker]="pickerTime"
                readonly
              />
              <mat-icon matSuffix (click)="pickerTime.open()">
                watch_later
              </mat-icon>
              <ngx-mat-timepicker
                #pickerTime
                enableKeyboardInput
              ></ngx-mat-timepicker>
            </mat-form-field>
          </div>

          <!-- Default  -->
          <div *ngSwitchDefault class="alert-notification-color">
            Error! Type not recognised
          </div>
        </span>
      </span>
    </div>

    <div class="filters-default-footer align-center-between">
      <div class="reset-filters-a" (click)="resetAction()">
        <a href="javascript:void(0)">{{
          'FILTERS.RESET-FILTERS' | translate
        }}</a>
      </div>
      <div class="filters-buttons-container">
        <button
          type="button"
          class="filter-cancel-btn"
          mat-flat-button
          (click)="cancelAction()"
        >
          {{ 'FILTERS.CANCEL' | translate }}
        </button>
        <button type="submit" mat-flat-button color="primary">
          {{ 'FILTERS.SUBMIT' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-menu>
